module.exports = __webpack_public_path__ + "static/pot1-bb2e00ecb096891a4c7b67c432926427.svg";